import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "container"
}
const _hoisted_2 = { class: "title-container" }
const _hoisted_3 = { class: "content-container" }
const _hoisted_4 = { class: "filter-container" }
const _hoisted_5 = {
  key: 0,
  class: "filter-site-container"
}
const _hoisted_6 = { class: "dataTable" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ReglePastille = _resolveComponent("ReglePastille")!
  const _component_ButtonBlue = _resolveComponent("ButtonBlue")!
  const _component_Filter = _resolveComponent("Filter")!
  const _component_BorderedIconButton = _resolveComponent("BorderedIconButton")!
  const _component_LoaderComponent = _resolveComponent("LoaderComponent")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_WaitingModal = _resolveComponent("WaitingModal")!
  const _component_ModalChoixSite = _resolveComponent("ModalChoixSite")!

  return (!_ctx.displayModalChoixSite)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", null, [
            _createTextVNode(_toDisplayString(_ctx.$t('preventive.page.title')) + " ", 1),
            _createVNode(_component_ReglePastille, { cle: "interventionPreventive.definition" })
          ])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            (!_ctx.isUniqueSite)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createTextVNode(_toDisplayString(_ctx.$t('intervention.non-preventive.filter')) + " ", 1),
                  _createVNode(_component_ReglePastille, { cle: "suiviInterventionsPreventives.filtreSiteUnique" }),
                  _createVNode(_component_ButtonBlue, {
                    "on-click": _ctx.selectionnerSite,
                    text: _ctx.$t('bouton.choix.site'),
                    class: "button-confirm btn",
                    disabled: _ctx.tableData.length === 0 && _ctx.isLoading || _ctx.filtreEquipementLoading || _ctx.filtreGroupeLoading
                  }, null, 8, ["on-click", "text", "disabled"])
                ]))
              : _createCommentVNode("", true),
            _createVNode(_component_Filter, {
              onSearch: _ctx.search,
              onSetInterventionId: this.setInterventionId,
              onSetPredictedDateFrom: this.setPredictedDateFrom,
              onSetPredictedDateTo: this.setPredictedDateTo,
              onAddFilterStatus: this.addFilterStatus,
              onAddFilterGroupe: this.addFilterGroupe,
              onRemoveFilterGroupe: this.removeFilterGroupe,
              onAddFilterSousGroupe: this.addFilterSousGroupe,
              onRemoveFilterSousGroupe: this.removeFilterSousGroupe,
              onAddFilterEquipement: this.addFilterEquipement,
              onRemoveFilterEquipement: this.removeFilterEquipement,
              onRemoveFilterStatus: this.removeFilterStatus,
              onClearFilter: this.clearFilter,
              onStatusToggleSelectAll: this.statusToggleSelectAll,
              onGroupeToggleSelectAll: this.groupeToggleSelectAll,
              onSousGroupeToggleSelectAll: this.sousGroupeToggleSelectAll,
              onEquipementToggleSelectAll: this.equipementToggleSelectAll,
              filter: this.filter,
              siteList: this.siteList,
              sousGroupeList: this.sousGroupeList,
              groupeList: this.groupeList,
              equipementList: this.equipementListFiltered,
              statusList: this.statusList,
              class: "filter"
            }, null, 8, ["onSearch", "onSetInterventionId", "onSetPredictedDateFrom", "onSetPredictedDateTo", "onAddFilterStatus", "onAddFilterGroupe", "onRemoveFilterGroupe", "onAddFilterSousGroupe", "onRemoveFilterSousGroupe", "onAddFilterEquipement", "onRemoveFilterEquipement", "onRemoveFilterStatus", "onClearFilter", "onStatusToggleSelectAll", "onGroupeToggleSelectAll", "onSousGroupeToggleSelectAll", "onEquipementToggleSelectAll", "filter", "siteList", "sousGroupeList", "groupeList", "equipementList", "statusList"])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", null, [
              _createElementVNode("h2", null, [
                _createTextVNode(_toDisplayString(_ctx.$tc('preventive.list.title', + this.count)) + " ", 1),
                _createVNode(_component_ReglePastille, { cle: "suiviInterventionsPreventives.portee" }),
                _createVNode(_component_ReglePastille, { cle: "suiviInterventionsPreventives.filtresEnCascade" })
              ]),
              (!_ctx.isExportDisabled)
                ? (_openBlock(), _createBlock(_component_BorderedIconButton, {
                    key: 0,
                    onClick: _ctx.exportXls,
                    imgUrl: _ctx.iconeXls,
                    title: _ctx.$t('list.export')
                  }, null, 8, ["onClick", "imgUrl", "title"]))
                : _createCommentVNode("", true),
              _createVNode(_component_ReglePastille, { cle: "suiviInterventionsPreventives.exportLimiteEquipements" })
            ]),
            (_ctx.tableData.length === 0 && _ctx.isLoading)
              ? (_openBlock(), _createBlock(_component_LoaderComponent, {
                  key: 0,
                  class: "loader"
                }))
              : (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  ref: "content",
                  onScroll: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleScroll && _ctx.handleScroll(...args))),
                  class: "datatable-container-smaller"
                }, [
                  _createVNode(_component_DataTable, {
                    count: +_ctx.count,
                    isLoading: _ctx.isLoading,
                    tableData: this.tableData,
                    tableHeader: this.tableHeader,
                    "stop-propa-on-pdf": true,
                    onDownloadPdf: _ctx.downloadPdf,
                    onSort: _ctx.doSort,
                    onSelect: _ctx.goToPage
                  }, null, 8, ["count", "isLoading", "tableData", "tableHeader", "onDownloadPdf", "onSort", "onSelect"])
                ], 544))
          ]),
          (_ctx.isExportXlsLoading)
            ? (_openBlock(), _createBlock(_component_WaitingModal, { key: 0 }))
            : _createCommentVNode("", true)
        ])
      ]))
    : (_openBlock(), _createBlock(_component_ModalChoixSite, {
        key: 1,
        onCancel: _ctx.modalChoixSiteCancel,
        onValider: _ctx.validerSite,
        "selected-site": null,
        "selected-sites": _ctx.filterSite,
        "is-multi-site": true,
        "inclure-termines": true
      }, null, 8, ["onCancel", "onValider", "selected-sites"]))
}